import React, { useState } from 'react';
import getLogger from '@ignitesales/logger-es';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormContainer from '../Forms/FormContainer';
import LocationsMap from './LocationMap';
import { ContactMessages } from '../../i18n/index';
import { ContactMeScreens as Screens } from '../../state/index';
import { LocationShape } from '../../utils/index';
import FormInput from '../Forms/FormInput';

const logger = getLogger({ component: 'ContactForm' });

const AppointmentLocationForm = (props) => {
  const {
    selectedLocation,
    locationSearchForm,
    setLocation,
    changeScreen,
    onLocationSearchChange,
    getLocations,
    availableLocations = [],
    isProcessing,
  } = props;

  const [searchValue, setSearchValue] = useState(
    locationSearchForm || { zipCode: '' }
  );

  const zipCodeFieldProps = {
    name: 'zipCode',
    type: 'string',
    initialValue: locationSearchForm.zipCode,
    onChange: ({value:v}) => {
      setSearchValue({ zipCode: v });
      onLocationSearchChange({ zipCode: v });
    }
  };

  const formSubmitted = () => {
    if (selectedLocation?.id) {
      changeScreen(Screens.APPT_CALENDAR);
    }
  };

  const buttonMessage = isProcessing
    ? <FormattedMessage {...ContactMessages.loading} />
    : <FormattedMessage {...ContactMessages.continue} />;

  const selectedLocationString =
    selectedLocation && selectedLocation.id ? (
      <div className="selectedLocationString">
        Selected Location:
        <span className="selectedLocationString__name">
          {selectedLocation.name}{' '}
        </span>
        <span className="selectedLocationString__address">
          {selectedLocation.address},{' '}
        </span>
        <span className="selectedLocationString__city">
          {selectedLocation.city}, {selectedLocation.state}{' '}
          {selectedLocation.postalCode}
        </span>
      </div>
    ) : null;

  const loadingOverlay = isProcessing ? (
    <div className="contactMe__loadingOverlay" />
  ) : null;

  return (
    <FormContainer
      formId="appointmentLocationForm"
      className="contactMe__form"
      onSubmit={ formSubmitted }
    >
      <div className="form-body">
        {loadingOverlay}
        <h5 className="form-description">
          <FormattedMessage
            {...ContactMessages.appointmentLocationFormMessage}
          />
        </h5>
        {selectedLocationString}
        <FormInput formId="appointmentLocationForm" { ...zipCodeFieldProps }/>
        <LocationsMap
          zipCode={searchValue.zipCode}
          onClick={setLocation}
          selectedLocation={selectedLocation}
          onGeoLocationChange={getLocations}
          onGeoLocationFailure={(ex) => {
            logger.error('Failed to get geo location coordinates', ex);
          }}
          locations={availableLocations}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA-tE9qr3vCaZsrv1KveSqhVOT_d9zZ39A&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div className="locationMap__loading" />}
          containerElement={<div className="locationMap" />}
          mapElement={<div className="locationMap__map" />}
        />
      </div>
      <div className="form-actions">
        <button type="submit" className="form-submitBtn" disabled={isProcessing}>{buttonMessage}</button>
      </div>
    </FormContainer>
  );
};

AppointmentLocationForm.propTypes = {
  fields: PropTypes.array,
  locationSearchForm: PropTypes.any,
  changeScreen: PropTypes.any,
  onLocationSearchChange: PropTypes.any,
  getLocations: PropTypes.any,
  availableLocations: PropTypes.any,
  isProcessing: PropTypes.any,
  schema: PropTypes.object,
  selectedScreen: PropTypes.string,
  searchFormValue: PropTypes.string,
  selectedLocation: LocationShape,
  setLocation: PropTypes.func,
  onScreenChange: PropTypes.func,
  changeZip: PropTypes.func,
};

export default AppointmentLocationForm;
